export const ZAC_VERSION = {
    "version": "4.7.2"
};
